module.exports = __webpack_public_path__ + "static/media/videoposter.1baaef72.jpg";